module.exports = __webpack_public_path__ + "static/media/cover_page_new.0b6ad17f.png";